import { put, takeLatest } from 'redux-saga/effects';

import { getMetricsAlertHistory } from 'api/metricsAlertHistory';
import * as constants from './constants';
import { actionStatus, statusAction, getError } from '../utils';
import { addNotification } from '../ui/notifications/actions';
import { NOTIFICATION_TYPE_INTERACTION } from '../../attrs/notifications';
import { generateId } from '../../helpers/utils';

function* handleLoadMetricsAlertHistory(params) {
  yield put(statusAction(constants.LOAD_MACHINE_METRICS_ALERT_HISTORY, actionStatus.START));
  try {
    const { data } = yield getMetricsAlertHistory(params);
    yield put(statusAction(constants.LOAD_MACHINE_METRICS_ALERT_HISTORY, actionStatus.SUCCESS, { payload: data }));
  } catch (err) {
    const error = getError(err);
    yield put(
      statusAction(constants.LOAD_MACHINE_METRICS_ALERT_HISTORY, actionStatus.ERROR, {
        message: error
      })
    );

    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `errors.alerts.${error}`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

export function* watchLoadOrders() {
  yield takeLatest(constants.LOAD_MACHINE_METRICS_ALERT_HISTORY, handleLoadMetricsAlertHistory);
}
